import { mapState, mapMutations } from 'vuex';
import ApiService from '../services/apiService';
import { themesMixin } from '../utils/themes';
export default {
  name: 'ViewResetPassword',
  mixins: [themesMixin],
  data: function () {
    return {
      valid: false,
      loading: false,
      email: '',
      showMessage: false,
      emailRules: [v => !!v, v => /.+@.+\..+/.test(v)]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme']),
    loginLogo() {
      return this.themeGetLogoObject();
    },
    loginBackground() {
      return this.themeGetBackground();
    }
  },
  mounted() {
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
  },
  beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    forgotPass() {
      this.loading = true;
      ApiService.resetPasswordRequest(this.email).then(() => {
        this.$snack(this.$i18n_t('Common.newPwdReq'), 'success');
        this.showMessage = true;
        this.$router.push('/');
      }).catch(() => {
        // THIS HAS BEEN CHANGED DUE TO PENETRATION TEST SWB
        // if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
        //   this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        // } else {
        // this.$snack(this.$i18n_t('Common.newPwdReqFail'), 'error');
        this.$snack(this.$i18n_t('Common.newPwdReq'), 'success');
        this.showMessage = true;
        this.$router.push('/');
        //}
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};